import { endpointFilterTypeDisplayMap } from '../../../constants/report/endpointFilterType';
import bespokeValidator from './bespokeValidator';
import clear from '../../common/array/clear';
import conditionValidator from './conditionValidator';
import EndpointFilter from '../../../../types/report/EndpointFilter';
import Lookup from '../../../../types/functions/Lookup';
import ReportCollections from '../../../types/Functions/ReportCollections';
import stringHelper from '../../common/stringHelper';
import uniquenessValidator from './uniquenessValidator';
import ReportVariable from '../../../../types/report/ReportVariable';
import Dictionary from '../../../../types/report/Dictionary';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import ErrorType from '../../../../types/report/ErrorType';

const maxNameCharacters = 50;

const validateFilter = (filter: EndpointFilter, functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], lookups: Lookup[], dictionaries: Dictionary[], variables: ReportVariable[],
    collections: ReportCollections, name: string, reportConfigType: string): void => {

    clear(filter.errors);

    let metadataError = validateMetadata(filter, name);
    if (metadataError) {
        filter.errors.push(metadataError);
    }

    if (!filter.isBespoke) {

        Array.prototype.push.apply(filter.errors, conditionValidator.validate(filter.condition, functions, globalFunctions, lookups, dictionaries, variables, collections.dataSources,
            collections.reportFields, null as any, true, null, reportConfigType));
        return;
    }

    let bespokeError = bespokeValidator.validateCondition(filter.bespokeCondition);
    if (bespokeError) {
        filter.errors.push(bespokeError);
    }
};

const validateMetadata = (filter: EndpointFilter, name: string): string | null => {

    if (stringHelper.isEmpty(filter.name)) {
        return `${name} name is required`;
    }

    if (filter.name.length > maxNameCharacters) {
        return `${name} name max character count is ${maxNameCharacters}`;
    }

    return null;
};

const validate = (filters: EndpointFilter[], functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], lookups: Lookup[], dictionaries: Dictionary[], variables: ReportVariable[],
    collections: ReportCollections, type: string, reportConfigType: string): string | null => {

    filters.forEach(x => validateFilter(x, functions, globalFunctions, lookups, dictionaries, variables, collections, type, reportConfigType));

    uniquenessValidator.validate(filters, f => f.name, type, 'name');

    let valid = filters.every(x => x.errors.length === 0);

    return valid ? null : `Invalid ${type.toLowerCase()}(s)`;
};

const validateByType = (filters: EndpointFilter[], functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], lookups: Lookup[], dictionaries: Dictionary[],
    collections: ReportCollections, type: string, variables: ReportVariable[] = [], reportConfigType: string): ErrorType => {

    validate(filters.filter(x => x.type === type), functions, globalFunctions, lookups, dictionaries, variables, collections, endpointFilterTypeDisplayMap[type], reportConfigType);

    let filterWithError = filters.find(f => f.type === type && f.errors.length > 0);

    return {
        message: filterWithError ? `Invalid ${type.toLowerCase()}(s)` : '',
        componentNumber: filterWithError?.number
    } as ErrorType;
};

const endpointFilterValidator = {
    validateByType
};

export default endpointFilterValidator;